export const admin = {
  title: "Administration",
  subtitle: "Verwalten Sie Nutzer, Kategorien und Systemeinstellungen",
  users: "Nutzer",
  categories: "Kategorien",
  broadcast: "Broadcast",
  messages: "Nachrichten",
  tickets: "Tickets",
  settings: "Einstellungen",
  system: "System",
  languages: "Sprachen",
  totalUsers: "Gesamt Nutzer",
  totalCategories: "Gesamt Kategorien",
  pendingSuggestions: "Offene Vorschläge",
  userManagement: "Nutzerverwaltung",
  userManagementDescription: "Verwalten Sie Nutzerkonten und Berechtigungen",
  userManagementSelfHiddenHint: "Ihr eigener Account wird in dieser Liste nicht angezeigt.",
  categoryManagement: "Kategorienverwaltung",
  broadcastManagement: "Broadcast-Verwaltung",
  languageManagement: "Sprachverwaltung",
  languageManagementDescription: "Verwalten Sie Übersetzungen für Deutsch und Englisch",
  errorPagesTest: "Fehlerseiten-Tests",
  errorPagesTestDescription: "Testen Sie die verschiedenen Fehlerseiten der Anwendung",
  actionLog: "Aktionsprotokoll & Rückgängig",
  actionLogDescription: "Letzte administrative Aktionen (können rückgängig gemacht werden)",
  systemStatus: "Systemstatus",
  systemStatusDescription: "Überwachen Sie den aktuellen Systemzustand",
  username: "Benutzername",
  email: "E-Mail",
  role: "Rolle",
  status: "Status",
  actions: "Aktionen",
  active: "Aktiv",
  suspended: "Gesperrt",
  admin: "Administrator",
  user: "Nutzer",
  joined: "Beigetreten",
  scheduleBroadcast: "Broadcast planen",
  broadcastSubject: "Betreff",
  broadcastMessage: "Nachricht",
  broadcastType: "Typ",
  broadcastTypeInfo: "Informationen",
  broadcastTypeWarning: "Warnung",
  broadcastTypeAlert: "Wichtiger Hinweis",
  startDate: "Startdatum",
  startTime: "Startzeit",
  endDate: "Enddatum",
  endTime: "Endzeit",
  fillAllFields: "Bitte füllen Sie alle Felder aus",
  endAfterStart: "Endzeitpunkt muss nach dem Startzeitpunkt liegen",
  broadcastScheduled: "Broadcast-Banner erfolgreich geplant",
  broadcastDescription: "Wird angezeigt von {start} bis {end}",
  addLanguage: "Sprache hinzufügen",
  newLanguage: "Neue Sprache hinzufügen",
  newLanguageDescription: "Fügen Sie eine neue Sprache zum System hinzu. Die deutschen Übersetzungen werden als Vorlage kopiert.",
  languageCode: "Sprachcode (z.B. fr, es, it)",
  languageName: "Sprachname",
  languageFlag: "Länderflagge",
  selectFlag: "Flagge wählen",
  availableLanguages: "Verfügbare Sprachen",
  chooseLanguage: "Wählen Sie eine Sprache zum Bearbeiten",
  editTranslation: "Übersetzung bearbeiten",
  key: "Schlüssel",
  value: "Wert",
  translations: "Übersetzungen",
  clickToEdit: "Klicken Sie auf eine Übersetzung, um sie zu bearbeiten",
  searchTranslations: "Übersetzungsschlüssel suchen",
  searchTranslationsPlaceholder: "Nach Schlüssel filtern...",
  translationColumnGerman: "Deutsch",
  translationColumnKey: "Schlüssel",
  translationColumnEnglish: "Englisch",
  translationMissing: "Fehlt",
  translationAddValue: "Hinzufügen",
  translationEditValue: "Bearbeiten",
  categoryNameGerman: "Kategoriename (Deutsch)",
  categoryNameEnglish: "Kategoriename (Englisch)",
  parentCategory: "Übergeordnete Kategorie",
  selectParent: "Wählen Sie eine übergeordnete Kategorie",
  noParent: "Keine (Hauptkategorie)",
  addCategory: "Kategorie hinzufügen",
  editCategory: "Kategorie bearbeiten",
  germanNameRequired: "Der deutsche Name ist erforderlich",
  categoryCreated: "Kategorie erfolgreich erstellt",
  categoryUpdated: "Kategorie erfolgreich aktualisiert",
  categoryDeleted: '"{name}" wurde gelöscht',
  deleteCategory: "Kategorie löschen?",
  deleteCategoryDescription: "Diese Aktion kann nicht rückgängig gemacht werden.",
  topLevelCategories: "Hauptkategorien",
  allCategories: "Alle Kategorien",
  inviteUser: "Nutzer einladen",
  inviteUserDescription: "Eine Einladungs-E-Mail mit Registrierungslink senden.",
  inviteEmail: "E-Mail-Adresse",
  inviteEmailPlaceholder: "name@beispiel.de",
  inviteEnglishLabel: "Einladung auf Englisch senden",
  inviteEmailRequired: "E-Mail-Adresse ist erforderlich",
  sendInvite: "Einladung senden",
  inviteSent: "Einladungs-E-Mail gesendet",
  searchUsers: "Nutzer suchen...",
  allUsers: "Alle Nutzer",
  admins: "Administratoren",
  suspendedUsers: "Gesperrt",
  deleteUser: "Nutzer löschen?",
  deleteUserDescription: "Möchten Sie den Nutzer wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
  userDeleted: "Nutzer wurde gelöscht",
  userSuspended: "Nutzer wurde gesperrt",
  userUnblocked: "Nutzer wurde entsperrt",
  userMadeAdmin: "ist jetzt Administrator",
  userUpdated: "Nutzer wurde aktualisiert",
  editUserTitle: "Nutzer bearbeiten",
  newCategory: "Neue Kategorie",
  addSubcategory: "Unterkategorie hinzufügen",
  parentCategoryColumn: "Übergeordnet",
  websitesColumn: "Websites",
  subcategoriesColumn: "Unterkategorien",
  none: "-",
  deleteCategoryConfirm: "Möchten Sie die Kategorie wirklich löschen? Alle Unterkategorien werden ebenfalls gelöscht.",
  broadcastToAllUsers: "Nachricht an alle Nutzer senden",
  broadcastToAllUsersDescription: "Senden Sie wichtige Mitteilungen an alle registrierten Nutzer",
  subjectRequired: "Betreff *",
  subjectPlaceholder: "z.B. Systemwartung",
  messageRequired: "Nachricht *",
  messagePlaceholder: "Nachrichtentext...",
  bannerTypeRequired: "Banner-Typ *",
  bannerTypeInfo: "Information (Blau)",
  bannerTypeWarning: "Warnung (Gelb)",
  bannerTypeAlert: "Wichtig (Rot)",
  startDateRequired: "Startdatum *",
  startTimeRequired: "Startzeit *",
  endDateRequired: "Enddatum *",
  endTimeRequired: "Endzeit *",
  bannerDisplayInfo: "Das Banner wird im angegebenen Zeitraum oben auf der Website angezeigt (direkt unter dem Header).",
  allVisitorsWillSee: "Alle Besucher sehen das Banner während des aktiven Zeitraums.",
  scheduleBanner: "Banner planen",
  reset: "Zurücksetzen",
  scheduledBanners: "Geplante & Aktive Banner",
  scheduledBannersDescription: "Übersicht aller Broadcast-Banner",
  scheduled: "Geplant",
  completed: "Abgeschlossen",
  administrators: "Administratoren",
  openSuggestions: "Offene Vorschläge",
  manageLanguages: "Sprachen verwalten",
  manageLanguagesDescription: "Sprachen und Übersetzungen verwalten",
  categoryManagementTitle: "Kategorieverwaltung",
  categoryManagementFullDescription: "Erstellen und verwalten Sie Kategorien",
  categoryTreeExpandNode: "Kategoriezweig ausklappen",
  categoryTreeCollapseNode: "Kategoriezweig einklappen",
  categoryDepthLimitHint:
    "Maximale Kategorietiefe: {max} Segmente (Root bis Blatt).",
  categoryDepthLimitReached:
    "Maximale Kategorietiefe erreicht ({max} Segmente).",
  moveCategoryTitle: "Websites verschieben",
  moveCategoryDescription:
    "Alle Websites aus \"{name}\" in eine andere Kategorie verschieben.",
  moveCategoryConfirm: "Verschieben",
  moveCategorySuccess: "{count} Websites verschoben",
  moveCategoryTargetRequired: "Bitte eine Zielkategorie auswählen.",
  tableUser: "Nutzer",
  tableRole: "Rolle",
  tableStatus: "Status",
  tableWebsites: "Websites",
  tableJoined: "Beigetreten",
  tableLogin: "Login",
  tableActions: "Aktionen",
  tableCategory: "Kategorie",
  tableParent: "Übergeordnet",
  tableSubcategories: "Unterkategorien",
  legalPages: "Rechtliche Seiten",
  legalPagesDescription: "Bearbeiten Sie Impressum, Datenschutzerklärung und Nutzungsbedingungen",
  legalNotice: "Impressum",
  privacyPolicy: "Datenschutzerklärung",
  termsOfService: "Nutzungsbedingungen",
  systemSettings: "System-Einstellungen",
  systemSettingsDescription: "Allgemeine Systemkonfiguration",
  systemSettingsEmpty: "Keine Systemeinstellungen verfügbar.",
  systemSettingsUnsupportedType:
    "Dieser Einstellungstyp wird noch nicht unterstützt.",
  systemSettingsItems: {
    emailVerificationEnabled: {
      label: "E-Mail-Verifizierung erforderlich",
      description:
        "Wenn aktiviert, bleiben geänderte E-Mails unverifiziert bis zur Bestätigung.",
      warning:
        "Der E-Mail-Versand ist auf Gmail beschränkt und hat strenge Kontingente. Bitte nicht übermäßig senden; zu viele E-Mails können blockiert werden.",
    },
    aiCategorySuggestionEnabled: {
      label: "KI-Kategorievorschläge",
      description:
        "Zeigt KI-gestützte Kategorievorschläge im öffentlichen Vorschlagsformular.",
    },
    mlSmartSearchEnabled: {
      label: "KI-Suche auf der Startseite",
      description:
        "Aktiviert die intelligente Startseiten-Suche mit automatischer Aufteilung in Text, Kategorie und Regionen.",
    },
    searchEngineMode: {
      label: "Suchmodus",
      description:
        "Legt fest, ob die Website-Suche PostgreSQL nutzt, OpenSearch im Schattenmodus testet oder direkt aus OpenSearch liest.",
      warning:
        "SHADOW und OPENSEARCH benötigen einen aktiven OpenSearch-Index.",
    },
    maintenanceModeEnabled: {
      label: "Wartungsmodus",
      description:
        "Blockiert Nicht-Admins und zeigt den Wartungshinweis auf öffentlichen Seiten.",
    },
    addressAutocompleteEnabled: {
      label: "Adress-Autovervollständigung",
      description:
        "Aktiviert Photon-basierte Adressvorschläge im Vorschlags- und Hinzufügen-Formular.",
    },
    ticketRetentionMonths: {
      label: "Ticket-Aufbewahrung (Monate)",
      description:
        "Geschlossene Tickets älter als dieser Wert werden durch den Cleanup-Job gelöscht.",
      warning:
        "Zulässig sind 1 bis 60 Monate. Standard ist 12 Monate.",
    },
    ticketForwardingEmail: {
      label: "Ticket-Weiterleitungsadresse",
      description:
        "Optionale E-Mail-Adresse für weitergeleitete Ticket-Updates (nur Links).",
      warning:
        "Leer lassen, um Weiterleitung zu deaktivieren. Anhänge werden nie per E-Mail gesendet.",
    },
    "webkurator.categories.catalog.hash": {
      label: "Kategorie-Katalog-Hash (nur lesen)",
      description:
        "Interner Integritätswert für den Kategoriensync beim Start. Wird automatisch vom Backend gesetzt.",
      warning:
        "Dieser Wert darf nicht manuell geändert werden. Änderungen am Katalog erfolgen über Git-Änderungen an backend/src/main/resources/data/newCategories.json und den folgenden Deploy/Restart.",
    },
  },
  newRegistrations: "Neue Registrierungen",
  newRegistrationsDescription: "Erlauben Sie neue Nutzerregistrierungen",
  websiteSuggestionsToggle: "Website-Vorschläge",
  websiteSuggestionsDescription: "Anonyme Nutzer können Websites vorschlagen",
  mlCategorization: "ML-Kategorisierung",
  mlCategorizationDescription: "Automatische Kategorievorschläge",
  enabled: "Aktiviert",
  disabled: "Deaktiviert",
  searchEngineModeApplied: "Suchmodus aktualisiert.",
  searchEngineModeRebuildStarted:
    "OpenSearch-Indexierung gestartet. Der Suchmodus wird nach erfolgreichem Abschluss automatisch umgestellt.",
  searchEngineModePending:
    "OpenSearch-Indexierung läuft. Änderungen am Suchmodus sind vorübergehend gesperrt.",
  searchEngineModeConfirmTitle: "OpenSearch-Index zuerst aufbauen?",
  searchEngineModeConfirmDescription:
    "Es existiert noch kein aktiver OpenSearch-Index. Der Aufbau kann dauern, weil alle aktiven Websites indexiert und die Aliase nach Abschluss umgeschaltet werden. Der gewählte Suchmodus wird danach automatisch aktiviert.",
  searchEngineModeConfirmAction: "Index aufbauen und wechseln",
  languageManagementTitle: "Sprachverwaltung",
  languageManagementFullDescription: "Verwalten Sie Übersetzungen und fügen Sie neue Sprachen hinzu",
  manageLanguagesButton: "Sprachen verwalten",
  errorPagesTests: "Fehlerseiten-Tests",
  errorPagesFullDescription: "Testen Sie die verschiedenen Fehlerseiten der Anwendung",
  error404: "404 - Seite nicht gefunden",
  error403: "403 - Zugriff verweigert",
  error500: "500 - Serverfehler",
  errorMaintenance: "Wartungsmodus",
  systemPanelFallbackItem: "Element",
  systemPanelFallbackSuggestion: "Neue Webseite",
  actionLogTitle: "Aktionsprotokoll & Rückgängig",
  actionLogFullDescription: "Letzte administrative Aktionen (können rückgängig gemacht werden)",
  categoryDeletedAction: 'Kategorie "{name}" gelöscht',
  userSuspendedAction: 'Nutzer "{name}" gesperrt',
  websiteDeletedAction: 'Website "{name}" gelöscht',
  agoMinutes: "Vor {count} Minuten",
  ago5Minutes: "Vor 5 Minuten",
  ago15Minutes: "Vor 15 Minuten",
  agoHour: "Vor 1 Stunde",
  agoHours: "Vor {count} Stunden",
  noMoreActions: "Keine weiteren Aktionen verfügbar",
  noMoreActionsDescription: "Aktionen älter als 24 Stunden können nicht rückgängig gemacht werden",
  systemStatusTitle: "Systemstatus",
  systemStatusFullDescription: "Überwachen Sie den aktuellen Systemzustand",
  databaseConnection: "Datenbank-Verbindung",
  apiStatus: "API-Status",
  backupSystem: "Backup-System",
  lastBackup: "Letztes Backup",
  statusActive: "Aktiv",
  statusOnline: "Online",
  statusFunctional: "Funktional",
  statusChecking: "Wird geprüft...",
  statusUnavailable: "Nicht verfügbar",
  start: "Start",
  end: "Ende",
  allUsersFilter: "Alle Nutzer",
  adminsFilter: "Administratoren",
  usersFilter: "Nutzer",
  suspendedFilter: "Gesperrt",
  deleteUserConfirmTitle: "Nutzer löschen?",
  deleteUserConfirmDescription: "Möchten Sie den Nutzer {username} wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
  deleteCategoryConfirmTitle: "Kategorie löschen?",
  deleteCategoryFullDescription: "Möchten Sie die Kategorie {name} wirklich löschen? Alle {count} Unterkategorien werden ebenfalls gelöscht.",
  broadcastSendToAll: "Nachricht an alle Nutzer senden",
  broadcastSendDescription: "Senden Sie wichtige Mitteilungen an alle registrierten Nutzer",
  userMessagesTitle: "Benutzernachrichten",
  userMessagesDescription: "Direkte Nachrichten an einzelne Nutzer senden.",
  ticketInboxDescription:
    "Verwalte Bug- und Feature-Tickets mit Verlauf, Antworten und Löschaktionen.",
  ticketStorageSummaryTitle: "Ticket-Speicher",
  ticketStorageSummaryDescription:
    "Speichernutzung für Ticket-Anhänge und Nachrichten.",
  ticketStorageTotal: "Gesamter Ticket-Speicher",
  ticketAttachmentTotal: "Gesamter Anhang-Speicher",
  ticketTotalItems: "Tickets / Nachrichten / Anhänge",
  ticketTopStorage: "Top-Tickets nach Anhangsgröße",
  ticketDeleteClosed: "Geschlossenes Ticket löschen",
  userMessagesRecipient: "Empfänger",
  userMessagesRecipientPlaceholder: "Nutzer auswählen",
  userMessagesSubject: "Betreff",
  userMessagesSubjectPlaceholder: "z. B. Update zu Ihrem Vorschlag",
  userMessagesBody: "Nachricht",
  userMessagesBodyPlaceholder: "Nachricht schreiben...",
  userMessagesSend: "Nachricht senden",
  userMessageSent: "Nachricht erfolgreich gesendet",
  scheduledActiveBanners: "Geplante & Aktive Banner",
  bannersOverview: "Übersicht aller Broadcast-Banner",
  emailVerificationTitle: "E-Mail-Verifizierung",
  emailVerificationDescription:
    "Verlangt eine Bestätigung nach Änderungen der E-Mail-Adresse.",
  emailVerificationToggle: "E-Mail-Verifizierung erforderlich",
  emailVerificationToggleDescription:
    "Wenn aktiviert, bleiben geänderte E-Mails unverifiziert bis zur Bestätigung.",
  emailVerificationWarning:
    "Der E-Mail-Versand ist auf Gmail beschränkt und hat strenge Kontingente. Bitte nicht übermäßig senden; zu viele E-Mails können blockiert werden.",
  categoryNameExists: "Kategoriename existiert bereits.",
  useractivityFetchingFailed: "Beim laden der Nutzeraktivität ist ein Fehler aufgetreten.",
  undoFailed: "Beim wiederherstellen der Aktion ist ein Fehler aufgetreten.",
  undoSuccess: "Wiederherstellen erfolgreich!",
  systemRebuildTitle: "Statistik-Zähler neu aufbauen",
  systemRebuildDescription:
    "Berechnet alle persistierten Zähler aus den aktuellen Daten neu.",
  systemRebuildStatus: "Rebuild-Status",
  systemRebuildIdle: "Inaktiv",
  systemRebuildRunning: "Läuft",
  systemRebuildCompleted: "Abgeschlossen",
  systemRebuildFailed: "Fehlgeschlagen",
  systemRebuildNoRunYet: "Es wurde noch kein Rebuild gestartet.",
  systemRebuildStart: "Rebuild starten",
  systemRebuildRefresh: "Status aktualisieren",
  systemRebuildStarted: "Statistik-Rebuild gestartet",
  systemRebuildStartFailed: "Statistik-Rebuild konnte nicht gestartet werden",
  systemRebuildLoadFailed: "Rebuild-Status konnte nicht geladen werden",
  systemRebuildConfirmTitle: "Statistik-Zähler-Rebuild starten?",
  systemRebuildConfirmDescription:
    "Dabei werden alle persistenten Statistik-Zähler aus den aktuellen Daten neu berechnet (Regionen, Kategorien, Tiefen-Zähler, Region-Kategorie-Zähler, globale Summen und Monatswerte). Bei großen Datenmengen kann das lange dauern und zusätzliche Datenbanklast erzeugen. Das ist normalerweise nur nötig, wenn Zähler nach Importen, Vorfällen oder fehlgeschlagenen Updates inkonsistent sind.",
  systemRebuildConfirmAction: "Rebuild jetzt starten",
  searchIndexRebuildTitle: "OpenSearch-Index neu aufbauen",
  searchIndexRebuildDescription:
    "Baut das ACTIVE-only OpenSearch-Lesemodell aus den PostgreSQL-Quelldaten neu auf.",
  searchIndexRebuildStatus: "Rebuild-Status",
  searchIndexRebuildIdle: "Inaktiv",
  searchIndexRebuildRunning: "Läuft",
  searchIndexRebuildCompleted: "Abgeschlossen",
  searchIndexRebuildFailed: "Fehlgeschlagen",
  searchIndexRebuildNoRunYet: "Es wurde noch kein OpenSearch-Rebuild gestartet.",
  searchIndexRebuildRunningHint:
    "Rebuild läuft im Backend. Das Read-Alias wird nach Abschluss umgeschaltet.",
  searchIndexRebuildLastFinishedAt: "Letzter Rebuild abgeschlossen um",
  searchIndexRebuildStart: "OpenSearch-Rebuild starten",
  searchIndexRebuildRefresh: "OpenSearch-Status aktualisieren",
  searchIndexRebuildStarted: "OpenSearch-Rebuild gestartet",
  searchIndexRebuildStartFailed:
    "OpenSearch-Rebuild konnte nicht gestartet werden",
  searchIndexRebuildLoadFailed: "OpenSearch-Status konnte nicht geladen werden",
  searchIndexRebuildConfirmTitle: "OpenSearch-Rebuild starten",
  searchIndexRebuildConfirmDescription:
    "Dabei wird ein neuer OpenSearch-Index erstellt und alle ACTIVE-Websites neu indexiert, bevor die Aliase umgeschaltet werden. Bei großen Datenmengen kann das lange dauern und zusätzliche Last auf Datenbank und Search-Cluster erzeugen.",
  searchIndexRebuildConfirmAction: "OpenSearch-Rebuild jetzt starten",
  searchIndexEngineMode: "Search-Engine-Modus",
  searchIndexDocsOnReadAlias: "Dokumente auf Read-Alias",
  searchIndexOutboxPending: "Outbox ausstehend",
  searchIndexOutboxFailed: "Outbox fehlgeschlagen",
  instanceMigrationTitle: "Instanz-Migration",
  instanceMigrationDescription:
    "Zieht Daten temporaer von der Docker-Instanz in diese Kubernetes-Instanz und speichert viele Checkpoints.",
  instanceMigrationDisabled:
    "Die temporaere Migrationsfunktion ist in der Backend-Konfiguration deaktiviert.",
  instanceMigrationSourceUrl: "Quell-Instanz",
  instanceMigrationPageSize: "Seitengroesse",
  instanceMigrationStatus: "Migrations-Status",
  instanceMigrationIdle: "Inaktiv",
  instanceMigrationQueued: "Geplant",
  instanceMigrationRunning: "Laeuft",
  instanceMigrationPaused: "Pausiert",
  instanceMigrationCompleted: "Abgeschlossen",
  instanceMigrationFailed: "Fehlgeschlagen",
  instanceMigrationCurrentPhase: "Aktuelle Phase",
  instanceMigrationCurrentDataset: "Aktueller Datensatz",
  instanceMigrationProcessed: "Verarbeitet",
  instanceMigrationElapsed: "Vergangen",
  instanceMigrationEta: "ETA",
  instanceMigrationLastCheckpoint: "Letzter Checkpoint",
  instanceMigrationSharedToken: "Shared-Token-Override",
  instanceMigrationSourceAdminEmail: "Quell-Admin-E-Mail-Override",
  instanceMigrationSourceAdminPassword: "Quell-Admin-Passwort-Override",
  instanceMigrationRequestTimeoutMs: "Request-Timeout (ms)",
  instanceMigrationOptionalOverride: "Leer lassen, um gespeicherten oder Standardwert zu behalten",
  instanceMigrationOverrideHint:
    "Du kannst Source-Token und Admin-Zugangsdaten hier fuer Start oder Resume angeben, ohne sie als Kubernetes-Secret zu hinterlegen.",
  instanceMigrationNoRunYet: "Es wurde noch kein Instanz-Migrationsjob gestartet.",
  instanceMigrationStart: "Migration starten",
  instanceMigrationResume: "Migration fortsetzen",
  instanceMigrationRefresh: "Status aktualisieren",
  instanceMigrationStarted: "Instanz-Migration gestartet",
  instanceMigrationStartFailed: "Instanz-Migration konnte nicht gestartet werden",
  instanceMigrationLoadFailed: "Instanz-Migrationsstatus konnte nicht geladen werden",
  instanceMigrationConfirmTitle: "Instanz-Migration starten?",
  instanceMigrationConfirmDescription:
    "Dabei werden Website-Daten in resumierbaren Batches von der konfigurierten Quell-Instanz importiert. Source-Nutzer werden nur auf lokale Konten oder den anonymen Systemnutzer gemappt; Nachrichten, Tickets, Broadcasts und andere Altlasten werden fuer mehr Geschwindigkeit uebersprungen.",
  instanceMigrationConfirmAction: "Migration jetzt starten",
  instanceMigrationDatasetProgress: "Datensatz-Fortschritt",
  instanceMigrationCounts: "Eingefuegt / Aktualisiert / Uebersprungen / Fehlgeschlagen",
  instanceMigrationEmptyDatasets: "Noch kein Datensatz-Fortschritt vorhanden.",
  instanceMigrationStorageTitle: "Migrations-Speicher",
  instanceMigrationStorageDatabase: "Datenbankgroesse",
  instanceMigrationStorageMeasured: "Migration jetzt",
  instanceMigrationStorageProjected: "Projektierte Migrationsgroesse",
  instanceMigrationStorageQuota: "Genehmigte Quota-Annahme",
  instanceMigrationStorageAdditional: "Geschaetztes Restwachstum",
  instanceMigrationStorageHeadroom: "Geschaetzter Import-Headroom",
  instanceMigrationStorageRows: "Zeilen",
  instanceMigrationStorageCurrent: "Aktuell",
  instanceMigrationStorageProjectedShort: "Projektion",
  instanceMigrationStorageAdditionalShort: "Zusaetzlich",
  instanceMigrationStorageTableIndexes: "Tabelle / Indizes",
  instanceMigrationStorageQuotaHint:
    "Aus PostgreSQL gemessen. Die 200Gi sind die genehmigte Quota-Annahme, nicht der freie Kubernetes-PVC-Speicher.",
  instanceMigrationStorageResumeWarning: "Speicher-Warnung:",
  instanceMigrationStorageOk: "OK",
  instanceMigrationStorageWarning: "Warnung",
  instanceMigrationStorageCritical: "Kritisch",
  instanceMigrationStorageUnknown: "Unbekannt",
  systemLogsTitle: "Backend-Logs",
  systemLogsDescription:
    "Anwendungs- und Parquet-Import-Logs durchsuchen (nur Admins).",
  systemLogsSource: "Quelle",
  systemLogsAll: "Alle",
  systemLogsSourceApplication: "Anwendung",
  systemLogsSourceParquet: "Parquet-Import",
  systemLogsLevel: "Level",
  systemLogsLogger: "Logger enthält",
  systemLogsLoggerPlaceholder: "z. B. WebsiteSearchService",
  systemLogsQuery: "Nachrichtensuche",
  systemLogsQueryPlaceholder: "Nachrichteninhalt suchen...",
  systemLogsApply: "Filter anwenden",
  systemLogsRefresh: "Aktualisieren",
  systemLogsResults: "Ergebnisse",
  systemLogsEmpty: "Keine Logeinträge gefunden.",
  systemLogsLoadFailed: "Backend-Logs konnten nicht geladen werden",
  systemActivityEmpty: "Keine Aktivitäten gefunden."
};

